export const descriptions = [
  {
    "baseType": "1x4",
    "description": "Up to 4 slots; ≤ 1x4 and ≤ 2x2"
  },
  {
    "baseType": "2x3",
    "description": "Up to 6 slots; ≤ 2x3"
  },
  {
    "baseType": "2x2",
    "description": "≤ 2x2 or smaller"
  },
  {
    "baseType": "2x1",
    "description": "Up to 2 slots; 1x1 and 2x1"
  },
  {
    "baseType": "Inform",
    "description": "Shows a button in the Menu to inform you an update is ready. Click it to see the list of changes on the Changelog page."
  },
  {
    "baseType": "Auto Update",
    "description": "Automatically updates the economy data when an update was detected."
  },
  {
    "baseType": "Auto Update and Sync",
    "description": "Automatically updates the economy data when an update was detected. If you are logged in, syncs your active filter to your account."
  },
  {
    "baseType": "Holding Alt Key",
    "description": "Shown normally instead of transparent & small when holding the Alt key"
  },
  {
    "baseType": "Small & Transparent",
    "description": "Shown small & transparent"
  },
  {
    "baseType": "Styled",
    "description": "Shown with a custom style; by default with a more transparent background."
  },
  {
    "baseType": "Highlight Leveling Rares",
    "description": "Shown normally. Instead, Leveling Rares are highlighted to stand out."
  },
];
